import { IconButtonComponent } from './../../../../common/buttons/icon-button/icon-button.component';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';

@Component({
    selector: 'product-view-wishlist-toggle',
    templateUrl: 'product-view-wishlist-toggle.html',
    styleUrl: './product-view-wishlist-toggle.scss',
    standalone: true,
    imports: [IconButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewWishlistToggleComponent extends WishlistToggleComponentDef {}
